import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import urlAppendParam from '@collaborator/npm_modules/dist/helpers/url/urlAppendParam';

var LangsMenuItem = function LangsMenuItem(_ref) {
  var name = _ref.name,
      currentPageUrl = _ref.currentPageUrl,
      isActive = _ref.isActive;
  var location = useLocation();
  var url = useMemo(function () {
    var urlForRedirect = window.location.pathname;

    if (window.location.search) {
      urlForRedirect += window.location.search;
    }

    return urlAppendParam(currentPageUrl, 'url', urlForRedirect);
  }, [location.pathname, location.search]);

  if (isActive) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown-flat-submenu__item active"
    }, name);
  }

  return /*#__PURE__*/React.createElement("a", {
    className: "dropdown-flat-submenu__item",
    href: url
  }, name);
};

export { LangsMenuItem };